import { apiGet, apiPost } from './api';
import type {
  DueReviewResponse,
  ReviewProgressResponse,
  PaginatedReviewHistoryResponse,
  ReviewRating,
  ReviewFilter,
  ReviewHistoryQueryParams,
} from '../types/review.types';

export const reviewService = {
  /**
   * Fetch vocabulary items due for review with summary statistics.
   */
  async getDueReviews(
    filter: ReviewFilter = 'due',
    limit = 50,
  ): Promise<DueReviewResponse> {
    return apiGet<DueReviewResponse>('/review', { filter, limit });
  },

  /**
   * Submit a spaced repetition review rating for a vocabulary item.
   */
  async submitReview(
    vocabularyId: string,
    rating: ReviewRating,
  ): Promise<ReviewProgressResponse> {
    return apiPost<ReviewProgressResponse, { rating: ReviewRating }>(
      `/review/${vocabularyId}`,
      { rating },
    );
  },

  /**
   * Fetch paginated review and learning history, ordered newest first.
   */
  async getReviewHistory(
    params?: ReviewHistoryQueryParams,
  ): Promise<PaginatedReviewHistoryResponse> {
    return apiGet<PaginatedReviewHistoryResponse>(
      '/review/history',
      params as Record<string, unknown>,
    );
  },
};
